var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.5 18.5v-9h-3V5h-3v4.5h-3v9h3V27h3v-8.5zm-6-3v-3h3v3zM13.5 22.5v-9h-3V5h-3v8.5h-3v9h3V27h3v-4.5zm-6-3v-3h3v3z",
    clipRule: "evenodd"
  })));
};
export default SvgFilter;